import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/sm`;

export const getStoreDealer = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-store-dealer`
});

export const getStores = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-stores`,
  body: storeInfo
});

export const getIndexSa = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store-manage/index-sa`,
  body: storeInfo
});

export const getIndexCustomer = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store-manage/index-customer`,
  body: storeInfo
});

export const getIndexReservation = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store-manage/index-reservation`,
  body: storeInfo
});

export const getStorePersonnel = (store_id) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-store-personnel`,
  body: {
    store_id
  }
});

export const updateSa = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store-manage/update-sa/${updateInfo.sa_id}`,
  body: updateInfo
});
